import React, {useState, useEffect} from 'react';
import axios from 'axios';
import {useHistory, Route, Redirect} from 'react-router-dom';

function ExhibitionPost(){
    
    const [name, setName] = useState('');
    const [museum, setMuseum] = useState('');
    const [genre, setGenre] = useState('');
    const [openingday, setOpeningday] = useState('');
    const [closingday, setClosingday] = useState('');
    const [modifyOpeningday, setModifyOpeningday] = useState('');
    const [modifyClosing_days, setModifyClosing_days] = useState('');
    const [tickets, setTickets] = useState('');
    const [website, setWebsite] = useState('');
    const [image, setImage] = useState('');
    const [image_copyright, setImage_copyright] = useState('');
    const [isFreeAdmission, setIsFreeAdmission] = useState('');
    const [isRecommendation, setIsRecommendation] = useState('');

    const history = useHistory();

    const [museumList, setMuseumList] = useState([]);

    useEffect(()=>{
        getMuseumList()
    },[])

    function getMuseumList(){
        axios.get('/api/museum_list/all')
        .then(museumListFromMongo=>{
            setMuseumList(museumListFromMongo.data)
        })
        .catch(error=>{
            console.log(error)
        })
    };

    const museumOptions = museumList.map(museum =>{
        return(
            <option key={museum._id} value={museum._id}>
                {museum.name}
            </option>
        )
    })

    
    function handleSubmit(event){
        event.preventDefault();
     
        axios.post('/api/exhibitions_upload', {
           name, museum, genre, openingday, closingday, modifyOpeningday, modifyClosing_days, tickets, website, image, image_copyright, isFreeAdmission, isRecommendation

        })
        .then(response=>{
            history.push('/exhibitions')
        })
        .catch(error=>{
            console.log(error)
        })
    }

    const genreList =['Contemporary art', 'Modern art', 'Classic art', 'Ancient art', 'Applied fine arts', 'Photograph']
    
    const genreOptions = genreList.map(genre =>{
        return(
            <option key={genre} value={genre}>
                {genre}
            </option>
        )
    })

    const freeAdmissionList =['Yes', 'No']

    const freeAdmissioOptions = freeAdmissionList.map(status =>{
        return(
            <option key={status} value={status}>
                {status}
            </option>
        )
    })

    const recommedationList =['Yes', 'No']

    const recommedationOptions = recommedationList.map(status =>{
        return(
            <option key={status} value={status}>
                {status}
            </option>
        )
    })



    return(
        <div className='exhibition_post'>
            <form method='POST' onSubmit={handleSubmit}>
                <div className='admin_post_flex'>
                <label>Name:</label>
                <input type='text' id='name' name='name' placeholder='name of exhibition' value={name} onChange={e=>setName(e.target.value)}/>
                </div>
                
                <div className='admin_post_flex'>
                <label>Museum:</label>
                <select id='museum' name='museum' value={museum} onChange={e=>setMuseum(e.target.value)}>
                <option hidden value=''>
                    Select museum
                </option>
                {museumOptions}
                </select>
                </div>

                <div className='admin_post_flex'>
                <label>Genre:</label>
                <select id='genre' name='genre' value={genre} onChange={e=>setGenre(e.target.value)}>
                <option hidden value=''>
                    Select genre
                </option>
                {genreOptions}
                </select>
                </div>

                <div className='admin_post_flex'>
                <label>Opeing Day:</label>
                <input type='date' id='openingday' name='openingday' placeholder='Address Of Museum' value={openingday} onChange={e=>setOpeningday(e.target.value)}/>
                </div>

                <div className='admin_post_flex'>
                <label>Closing Day:</label>
                <input type='date' id='closingday' name='closingday' placeholder='City Name Of Address of museum' value={closingday} onChange={e=>setClosingday(e.target.value)}/>
                </div>

                <div className='admin_post_flex'>
                <label>Tickets:</label>
                <input type='text' id='tickets' name='tickets' placeholder='Tickets' value={tickets} onChange={e=>setTickets(e.target.value)}/>
                </div>

                <div className='admin_post_flex'>
                <label>Web-Site:</label>
                <input type='text' id='web-site' name='web-site' placeholder='Web-Site' value={website} onChange={e=>setWebsite(e.target.value)}/>
                </div>

                <div className='admin_post_flex'>
                <label>Image Url:</label>
                <input type='text' id='image' name='image' placeholder='Image' value={image} onChange={e=>setImage(e.target.value)}/>
                </div>

                <div className='admin_post_flex'>
                <label>Image Copyright:</label>
                <input type='text' id='image-copyright' name='image-copyright' placeholder='Image-Copyright' value={image_copyright} onChange={e=>setImage_copyright(e.target.value)}/>
                </div>

                <div className='admin_post_flex'>
                <label>Is Free Admission? :</label>
                <select id='isFreeAdmission' name='isFreeAdmission' value={isFreeAdmission} onChange={e=>setIsFreeAdmission(e.target.value)}>
                <option hidden value=''>
                    Select Status
                </option>
                {freeAdmissioOptions}
                </select>
                </div>

                <div className='admin_post_flex'>
                <label>Is Your Recommendation? :</label>
                <select id='isRecommendation' name='isRecommendation' value={isRecommendation} onChange={e=>setIsRecommendation(e.target.value)}>
                <option hidden value=''>
                    Select Status
                </option>
                {recommedationOptions}
                </select>
                </div>
  
                <input type='submit' value='Submit'/>
            </form>
        </div>
    )
}

export default ExhibitionPost;